import React, { useState } from 'react';
import Select from '@lwt-helix/select';
import * as EmailValidator from 'email-validator';

const InviteSelect = ({ setIsEmailValid, setEmailValidationNotification, options, permissions, setEmailList }) => {
        const defaultColor = 'hsl(0,0%,70%)';
        const [color, setColor] = useState(defaultColor);

        const handleChange = event => {
            // need to add case for "existing" after LWA data is available, color = yellow
            if (event?.length) {
                if (event.every(index => isValidEmail(index.value))) {
                    setIsEmailValid(true);
                    setEmailValidationNotification(null);
                    setColor(defaultColor);

                    // M-R is View Members permission
                    if (permissions?.hasOwnProperty('M-R')
                        && options?.length > 0
                        && !event.every(index => index.hasOwnProperty('primaryEmailAddress'))
                    ) {
                        setEmailValidationNotification('notRosterMember');
                    }

                    setEmailList(event);

                } else {
                    setIsEmailValid(false);
                    setEmailValidationNotification('invalid');
                    setColor('red');
                }
            } else {
                setIsEmailValid(false);
                setEmailValidationNotification(null);
                setColor(defaultColor);
            }
        };

        const formatOptionLabel = (option, optionMeta) => {
            if (optionMeta.context === 'menu')
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>{`${option.label}`}</div>
                        <div>{`${option?.value}`}</div>
                    </div>
                );
            else
                return `${option.label}`
        };

        const isValidEmail = (inputText) => {
            return EmailValidator.validate(inputText);
        };

        const customStyles = {
            control: base => ({
                ...base,
                borderColor: color,
                boxShadow: color,
                '&:hover': {
                    borderColor: color
                }
            })
        };

        return (
            <Select
                dataLwtId="agent-email-select"
                isMulti
                isCreatable
                onChange={handleChange}
                closeMenuOnSelect={false}
                options={options}
                formatOptionLabel={formatOptionLabel}
                placeholder={'Find existing agents or enter a new email address...'}
                styles={customStyles}
            />
        )
    }
;

export default InviteSelect;